import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'VyntraWeb - Création Site Web Thionville, Metz | Restaurant, Coiffeur',
  description = 'Agence web à Thionville spécialisée commerces locaux. Sites professionnels pour restaurants, pizzerias, coiffeurs. Visible sur Google, 0% commission. À partir de 49€/mois. Metz, Luxembourg, Yutz, Hayange.',
  canonical = 'https://vyntraweb.fr',
  ogImage = 'https://vyntraweb.fr/og-image.jpg',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noindex = false,
  structuredData = null,
  keywords = 'création site web Thionville, agence web Metz, site internet restaurant, site pizzeria, site coiffeur, référencement local, SEO Thionville, site commerce local, Yutz, Hayange, Fameck, Luxembourg'
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Robots */}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'} />
      
      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:alt" content="VyntraWeb - Création de sites web pour commerces locaux" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="VyntraWeb" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:locale:alternate" content="en_US" />
      
      {/* hreflang pour signaler la langue à Google */}
      <link rel="alternate" hrefLang="fr-FR" href={canonical} />
      <link rel="alternate" hrefLang="fr" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:creator" content="@vyntraweb" />
      <meta name="twitter:site" content="@vyntraweb" />
      
      {/* Additional SEO */}
      <meta name="author" content="Enzo Persch-Chiugi - VyntraWeb" />
      <meta name="language" content="fr" />
      <meta name="content-language" content="fr-FR" />
      <meta name="geo.region" content="FR-GES" />
      <meta name="geo.placename" content="Thionville, Grand Est, France" />
      <meta name="geo.position" content="49.3567;6.1686" />
      <meta name="ICBM" content="49.3567, 6.1686" />
      
      {/* Mobile & Performance */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      
      {/* Security */}
      <meta name="referrer" content="origin-when-cross-origin" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
